import { ShieldOff } from "lucide-react";
import { useTranslation } from "react-i18next";

type NoAccessProps = {
  className?: string;
};

export default function NoAccess({ className }: NoAccessProps) {
  const { t } = useTranslation();

  return (
    <div
      className={
        className ??
        "flex min-h-[50vh] flex-col items-center justify-center gap-3 px-4 text-center"
      }
      role="status"
    >
      <ShieldOff className="h-12 w-12 text-gray-300 dark:text-gray-600" aria-hidden />
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
        {t("errors.noAccessTitle")}
      </h2>
      <p className="max-w-md text-sm text-gray-500 dark:text-gray-400">
        {t("errors.noAccessDescription")}
      </p>
    </div>
  );
}
